import React from 'react';

import { Container } from 'styles';
import * as S from './styles';

const Breadcrumb = ({ links, currentPageName }) => {

	return (
        <Container>
            <S.BreadcrumbGroup>
                <S.BreadcrumbItem to="/">Início</S.BreadcrumbItem>
                {links && links.map(link => <S.BreadcrumbItem key={link.name} to={link.to}>{link.name}</S.BreadcrumbItem>)}
                <S.BreadcrumbCurrentItem>{currentPageName}</S.BreadcrumbCurrentItem>
            </S.BreadcrumbGroup>
        </Container>
	);
}

export default Breadcrumb;